import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, FormattedNumber} from "react-intl";

import {styled} from "@mui/material/styles";

import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";
import ListingCtrBadge from "./ListingCtrBadge";
import {black500, greyishBlue400} from "assets/jss/main";

ListingSalesCell.propTypes = {
    // no data yet: both display N/A when null
    onlineSales: PropTypes.number,
    totalSales: PropTypes.number,
    ctr: PropTypes.number,
};

const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
});

// 104px, fixed — the column takes its width from these blocks, every column but the last
// one being fixed.
const Block = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    width: '104px'
});

const ValueRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
});

const Value = styled('span')({
    color: black500,
    fontSize: '14px',
    fontWeight: 600,
    whiteSpace: 'nowrap'
});

const Label = styled('span')({
    color: greyishBlue400,
    fontSize: '12px',
    whiteSpace: 'nowrap'
});

// "Ventes totales" = online sales + estimated store sales; N/A (null) only
// when neither counter is carried by the ES document yet (pre-reindex)
export const computeTotalSales = (item) =>
    null === item.onlineSales && null === item.storeSales
        ? null
        : (item.onlineSales ?? 0) + (item.storeSales ?? 0);

const SalesValue = ({value}) => (
    <Value>{null === value || undefined === value ? 'N/A' : <FormattedNumber value={value}/>}</Value>
);

function ListingSalesCell({onlineSales, totalSales, ctr}) {
    return (
        <Container>
            <Block>
                <ValueRow>
                    <SalesValue value={onlineSales}/>
                    <InfoTooltipIcon titleId={"retailer.product.list.sales.online.tooltip"}/>
                </ValueRow>
                <Label>
                    <FormattedMessage id={"retailer.product.list.sales.online"}/>
                </Label>
            </Block>
            <Block>
                <ValueRow>
                    <SalesValue value={totalSales}/>
                    <InfoTooltipIcon titleId={"retailer.product.list.sales.total.tooltip"}/>
                </ValueRow>
                <Label>
                    <FormattedMessage id={"retailer.product.list.sales.total"}/>
                </Label>
            </Block>
            <ListingCtrBadge ctr={ctr}/>
        </Container>
    );
}

export default ListingSalesCell;
